import { createContext } from 'react';
import createCollaborationSidebarState from '../factories/CollaborationSidebarState';

const NO_OP = () => {};

export default /*#__PURE__*/createContext({
  collaborationSidebarState: createCollaborationSidebarState(),
  onUpdateCollaborationSidebarState: NO_OP
});